$(document).on('turbolinks:load', function() {
  $('#order_detail_employee_id').change(function(){
      SupporterAjax();
  });
});
//CSRFトークンを取得・セット
function set_csrftoken() {
    $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        if (!options.crossDomain) {
            const token = $('meta[name="csrf-token"]').attr('content');
            if (token) {
                return jqXHR.setRequestHeader('X-CSRF-Token', token);
            }
        }
    });
}
function SupporterAjax(){
    //  ajax通信条件にCSRFトークンを入れる
    set_csrftoken()
    //下記情報にてリクエストを送信し、Railsのactionを呼び出す
    $.ajax({
      type: 'POST',
      //下記にアクセスすることでControllerのActionを呼び出す
      url: '/get_supporter',
      //パラメータに選択されている起因物大分類のidを持たせる
      data: {
       employee_id : $('#order_detail_employee_id').val()
      }
    }).done(function(data) {
      //HTMLの一部を更新する
      $('.supporter-area').html(data);
    });
}
